export { default as useLifestylesIndexPageSelectedLifestyles } from './useLifestylesIndexPageSelectedLifestyles';
